export const year2020 = [
  { year: '2020' },
  {
    name: 'How to GraphQL',
    author: 'Various Authors',
    type: 'Tutorial',
    link: 'https://www.howtographql.com/',
    repo: 'https://github.com/andreidobrinski/how-to-graphql-tutorial'
  },
  {
    name: 'Cybersecurity at Work',
    author: 'Caroline Wong',
    type: 'Course',
    link: 'https://www.linkedin.com/learning/cybersecurity-at-work/',
    repo: 'https://github.com/andreidobrinski/cybersecurity-at-work-li-learning'
  },
  {
    name: 'Learning Webpack 4',
    author: 'Eve Porcello',
    type: 'Course',
    link: 'https://www.linkedin.com/learning/learning-webpack-4/',
    repo: 'https://github.com/andreidobrinski/webpack-li-learning'
  },
  {
    name: 'Learning Webpack 3',
    author: 'Eve Porcello',
    type: 'Course',
    link: 'https://www.linkedin.com/learning/learning-webpack-3/',
    repo: 'https://github.com/andreidobrinski/webpack-li-learning'
  },
  {
    name: 'Learning Webpack 1',
    author: 'Eve Porcello',
    type: 'Course',
    link: 'https://www.linkedin.com/learning/learning-webpack-1/',
    repo: 'https://github.com/andreidobrinski/webpack-li-learning'
  },
  {
    name: 'React Testing Masterclass',
    author: 'Kati Frantz',
    type: 'Course',
    link: 'https://katifrantz.com/course/react-testing-masterclass',
    repo: 'https://github.com/andreidobrinski/react-testing-masterclass-course',
  },
  {
    name: 'Node with React: Fullstack Web Development',
    author: 'Stephen Grider',
    type: 'Course',
    link: 'https://www.udemy.com/course/node-with-react-fullstack-web-development',
    repo: 'https://github.com/andreidobrinski/node-with-react-fullstack-course-udemy',
  },
  {
    name: 'Docker and Kubernetes: The Complete Guide',
    author: 'Stephen Grider',
    type: 'Course',
    link: 'https://www.udemy.com/course/docker-and-kubernetes-the-complete-guide/',
    repo: 'https://github.com/andreidobrinski/docker-kubernetes-course-udemy',
  },
  {
    name: 'JSP Tutorial',
    author: 'TutorialsPoint',
    type: 'Tutorial',
    link: 'https://www.tutorialspoint.com/jsp/index.htm',
  },
  {
    name: 'Play by Play: What You Need to Know About HTTPS Today',
    author: 'Troy Hunt and Lars Klint',
    type: 'Course',
    link: 'https://www.pluralsight.com/courses/play-by-play-https-what-you-need-know-about-today',
    repo: 'https://github.com/andreidobrinski/pluralsight-security-courses/blob/master/what-you-need-to-know-about-https-today.md',
  },
  {
    name: 'Play by Play: JavaScript Security',
    author: 'Troy Hunt and Aaron Powell',
    type: 'Course',
    link: 'https://www.pluralsight.com/courses/play-by-play-javascript-security',
    repo: 'https://github.com/andreidobrinski/pluralsight-security-courses/blob/master/js-security.md',
  },
  {
    name: 'Play by Play: OWASP Top 10 2017',
    author: 'Andrew van der Stock and Troy Hunt',
    type: 'Course',
    link: 'https://www.pluralsight.com/courses/play-by-play-owasp-top-ten-2017',
    repo: 'https://github.com/andreidobrinski/pluralsight-security-courses/blob/master/owasp-top-10-2017.md',
  },
  {
    name: 'Defending Against JavaScript Keylogger Attacks on Payment Card Information',
    author: 'John Elliott and Troy Hunt',
    type: 'Course',
    link: 'https://www.pluralsight.com/courses/defending-javascript-keylogger-attacks-pci',
    repo: 'https://github.com/andreidobrinski/pluralsight-security-courses/blob/master/defending-against-JS-keylogger-ps-course.md',
  },
  {
    name: 'Payment Card Security, Processing, and the PCI Standards',
    author: 'John Elliott',
    type: 'Course',
    link: 'https://www.pluralsight.com/courses/payment-card-security-processing-pci-standards',
    repo: 'https://github.com/andreidobrinski/pluralsight-security-courses/blob/master/payment-card-security-processing-and-the-PCI-standards.md',
  },
  {
    name: 'Testing React Applications with Jest',
    author: 'Daniel Stern',
    type: 'Course',
    link: 'https://app.pluralsight.com/library/courses/testing-react-applications-jest',
    repo: 'https://github.com/andreidobrinski/testing-react-applications-with-jest-ps',
  },
  {
    name: 'React: Using TypeScript',
    author: 'Emmanuel Henri',
    link: 'https://www.linkedin.com/learning/react-using-typescript',
    repo: 'https://github.com/andreidobrinski/react-using-typescript-li-learning',
    type: 'Course',
  },
  {
    name: `Typescript: The Complete Developer's Guide [2020]`,
    author: 'Stephen Grider',
    link: 'https://www.udemy.com/course/typescript-the-complete-developers-guide/',
    repo: 'https://github.com/andreidobrinski/typescript-course-udemy',
    type: 'Course',
  },
];